import type { AxiosResponse } from 'axios';
import type { GenericApiResponseScheduledChangeDetail } from '@/common/api/models';

/** Poll interval while go-live is in progress (spec: 30 s). */
export const APPLYING_DETAIL_REFETCH_MS = 30_000;

type DetailQuerySnapshot = {
  state: {
    data?: AxiosResponse<GenericApiResponseScheduledChangeDetail>;
  };
};

/**
 * React Query refetchInterval callback for scheduled-change detail.
 * Polls only while the loaded record is `applying`.
 */
export function scheduledChangeDetailRefetchInterval(
  query: DetailQuerySnapshot,
): number | false {
  const state = query.state.data?.data?.data?.state;
  return state === 'applying' ? APPLYING_DETAIL_REFETCH_MS : false;
}
